/* Types of payment methods (from order service) */
export enum PaymentMethod {
    NotSelected = '',
    Credit = 'CREDIT',
    UserInstrument = 'USER_INSTRUMENT',
    Ideal = 'IDEAL',
    MaestroBancontact = 'MAESTRO_BANCONTACT',
    Sofort = 'SOFORT',
    NonceBraintree = 'NONCE_BRAINTREE',
    SepaDirectDebit = 'SEPA_DIRECT_DEBIT',
    FPPPaypal = 'PAYPAL',
    Cash = 'CASH',
    Check = 'CHECK',
    Invoice = 'INVOICE',
    StripeConfirmationToken = 'STRIPE_CONFIRMATION_TOKEN',
}
